import {MyProfileView} from '../../configuration-management/components/MyProfileView'
import {
  ListViewProvider,
  useListView,
} from '../../members-management/users-list/core/ListViewProvider'
import {UserEditModal} from '../../members-management/users-list/user-edit-modal/UserEditModal'
import {QueryRequestProvider} from '../../members-management/users-list/core/QueryRequestProvider'
import {QueryResponseProvider} from '../../members-management/users-list/core/QueryResponseProvider'
import {useProfilePageQuery} from './ProfilePageContext'

const UsersList: React.FC<Props> = ({userType, customerCode}) => {
  const {itemIdForUpdate} = useListView()
  const {data: profilePage} = useProfilePageQuery()
  const profileAccount = profilePage?.account

  return (
    <>
      <MyProfileView className={''} />
      {itemIdForUpdate !== undefined && (
        <UserEditModal
          userType={userType}
          customerCode={Number(profileAccount?.fK_Customer ?? customerCode) || 0}
        />
      )}
    </>
  )
}

type Props = {
  userType: string
  customerCode: number
}

const UserListEditInProfile: React.FC<Props> = ({userType, customerCode}) => (
  <QueryRequestProvider>
    <QueryResponseProvider userType={userType} customerCode={customerCode}>
      <ListViewProvider>
        <UsersList userType={userType} customerCode={customerCode} />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {UserListEditInProfile}
